export const dictionary = {};
